// Default Libraries
import { createActions } from '../helpers/redux';

export const ToastActions = createActions({
  createToast(toast) {
    return ({ dispatch }) => {
      setTimeout(() => {
        dispatch(ToastActions.deleteToast());
      }, 5000);

      return {
        toast,
      };
    };
  },
  deleteToast() {
    return {};
  },
});



// WEBPACK FOOTER //
// ./src/actions/toast.js